export default __webpack_public_path__ + "8620f072a93aeb0a046de698d8751b29.png";